export default function UnknownFilter() {
  return <div>This variable type is not currently handled.</div>;
}
